import { FunctionComponent } from 'react'
import { useTheme } from '@opallabs/hooks'
import { styles } from './styles'
import { HeadingProps, HeadingSize } from './types'

export { HeadingSize }

export const SectionHeading: FunctionComponent<HeadingProps> = ({
  children,
  className,
  id,
  level = 1,
  overrideStyles = {},
  size = HeadingSize.xLarge,
}: HeadingProps) => {
  const theme = useTheme()

  const HeadingTag = `h${level}` satisfies keyof JSX.IntrinsicElements

  return (
    <HeadingTag
      className={className}
      css={[styles(size, theme), overrideStyles]}
      id={id}
    >
      {children}
    </HeadingTag>
  )
}
SectionHeading.displayName = 'Lapidary: SectionHeading'
